"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAndroidWebView = void 0;

var _getWindowObject2 = require("./get-window-object");

var isAndroidWebView = function isAndroidWebView() {
  var _getWindowObject$user, _getWindowObject;

  return /android/i.test((_getWindowObject$user = (_getWindowObject = (0, _getWindowObject2.getWindowObject)('navigator')) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.userAgent) !== null && _getWindowObject$user !== void 0 ? _getWindowObject$user : '');
};

exports.isAndroidWebView = isAndroidWebView;
//# sourceMappingURL=is-android-webview.js.map